import { LOCAL_STORAGE_OIDC_TOKEN_NAME } from '@constants';
import Layout from '@product-framework/components/Layout';
import { LoadingEvent, useDataProvider } from '@ui-framework/index';
import { GetDomain } from '@utils/index';
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

function ApiDocumentation() {
  const theme = useTheme();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl, get } = useDataProvider(provider);

  const domain = GetDomain(process.env.REACT_APP_API_HOST, '', true);

  const getApiDocumentation = async () => {
    const apiUrl = `${getApiUrl()}/sxcl/v1/swagger`;
    try {
      const response = await get(apiUrl);
      return response.data;
    } catch (error) {
      return [];
    }
  };

  const initialize = async () => {
    setLoading(true);
    const response = await getApiDocumentation();
    if (response) {
      setDocuments(response);
    }
    setLoading(false);
  };
  useEffect(() => {
    initialize();
  }, []);

  // swagger-ui ships a full dark theme behind `html.dark-mode`. Opting into it
  // beats overriding its selectors one at a time. Scoped to this page so the
  // class does not leak to the rest of the app.
  useEffect(() => {
    if (theme.palette.mode !== 'dark') {
      return undefined;
    }
    const html = document.documentElement;
    const previousBackground = html.style.background;
    html.classList.add('dark-mode');
    // that class also carries an unscoped `html.dark-mode{background:#1c2022}`,
    // which would show through on overscroll. Inline style outranks it.
    html.style.background = theme.palette.background.content;
    return () => {
      html.classList.remove('dark-mode');
      html.style.background = previousBackground;
    };
  }, [theme.palette.mode, theme.palette.background.content]);

  return (
    <Layout>
      {loading ? (
        <LoadingEvent />
      ) : (
        documents && (
          <SwaggerUI
            spec={documents}
            docExpansion="none"
            defaultModelExpandDepth={2}
            defaultModelsExpandDepth={4}
            showExtensions
            showCommonExtensions
            supportedSubmitMethods={documents['x-supportedSubmitMethods'] || []}
            requestInterceptor={req => {
              const url = new URL(req.url);
              const path = url.pathname + url.search;
              req.url = `${domain}${path}`;
              const tokenName = window.localStorage.getItem(
                LOCAL_STORAGE_OIDC_TOKEN_NAME,
              );
              const sessionAuthData = tokenName
                ? window.localStorage.getItem(tokenName)
                : null;
              const token = sessionAuthData
                ? JSON.parse(sessionAuthData)?.access_token
                : null;
              if (token) {
                req.headers.Authorization = `Bearer ${token}`;
              }
              return req;
            }}
          />
        )
      )}
    </Layout>
  );
}
export default ApiDocumentation;
